import { NgModule, inject } from '@angular/core';
import { ApolloClient, ApolloLink, CombinedGraphQLErrors, InMemoryCache, ServerError } from '@apollo/client/core';
import { SetContextLink } from '@apollo/client/link/context';
import { ErrorLink } from "@apollo/client/link/error";
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { rollbarFactory } from './rollbar';
import { typePolicies } from './graphql-type-policies';

const uri = environment.graphQLUrl;
export function createApollo(httpLink: HttpLink, toastr: ToastrService): ApolloClient.Options {

  const rollbar = rollbarFactory();

  const auth = new SetContextLink(() => {
    const jwt = localStorage.getItem('jwt');

    if (jwt === null) {
      return {};
    }

    return {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    };
  });

  const errorHandler = new ErrorLink(({ error }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.forEach(({ message, locations, path }) => {
        rollbar.error(message, { location: locations, path: path })
      });
    } else {
      if (ServerError.is(error) && error.statusCode === 401) {
        localStorage.removeItem('jwt');
        localStorage.removeItem('account');
        toastr.error('Ein Problem ist aufgetreten, bitte melde dich erneut an!')
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        toastr.error("Daten können aktuell nicht geladen werden!");
        rollbar.error(error);
      }
    }
  });

  const inMemoryCache = new InMemoryCache({ typePolicies });

  return {
    link: ApolloLink.from([errorHandler, auth, httpLink.create({ uri })]),
    cache: inMemoryCache,
    // Apollo Client 4 defaults to true, which emits loading states without
    // data. Keep the Apollo Client 3 behaviour the components rely on.
    defaultOptions: {
      watchQuery: { notifyOnNetworkStatusChange: false },
    },
  };
}

@NgModule({
  providers: [
    provideApollo(() => createApollo(inject(HttpLink), inject(ToastrService))),
  ],
})
export class GraphQLModule { }
